<template>
  <v-toolbar v-if="!$store.getters.getMobilePhoneActive" fixed clipped-left dark app class="zindex" color="white">
    <v-toolbar-title style="width: 350px; height: 85px" class="ml-0 pl-0 pr-2">
      <!-- <v-btn class="ml-4" icon large> -->
      <v-layout align-center style="height: 100px">
        <img :src="headerImage()" @click="goToHome()" style="height: 60px; cursor: pointer;" alt="theDrivingForce" />
      </v-layout>
      <!-- </v-btn> -->
    </v-toolbar-title>
    <v-toolbar-items class="mt-3 hidden-sm-and-down" v-if="$store.getters.getCurrentMainComponent == 'HomePage' && $store.getters.getVisitorActive">
      <v-btn
        :class="['mr-5, text-xs-center, text-capitalize']"
        :style="getSelectedStyleElement(item)"
        v-for="(item, index) in toolbarItems"
        :key="index"
        flat
        v-if="!item.noShow"
        color="primary"
        round
        @click="goToNavigation(item)"
      >{{item.title}}</v-btn>
    </v-toolbar-items>
    <v-toolbar-items class="mt-3 hidden-sm-and-down" v-else-if="$store.getters.getCurrentMainComponent !== 'HomePage' && $store.getters.getVisitorActive">
      <v-btn
        v-if="$store.getters['auth/userLevel'] >= 6"
        :class="['mr-5, text-xs-center, text-capitalize']"
        flat
        color="primary"
        round
        @click="goToHome()"
      >{{$translate('THEME_LIST')}}</v-btn>
    </v-toolbar-items>
    <v-toolbar-items class="mt-3 hidden-sm-and-down" v-else>
      <v-btn
        style="opacity: 0.6;"
        :class="['mr-5, text-capitalize']"
        :style="`color: ${$vuetify.theme.primary}`"
        v-for="(item, index) in toolbarButtons"
        :key="index"
        :flat="!item.selected"
        round
        color="light grey"
        @click="selectItem(item)"
      >{{item.title}}</v-btn>
    </v-toolbar-items>
    <v-layout v-if="currentUserLevel < 6" row justify-end>

      <!--       <v-btn v-if="!$store.getters.getMobilePhoneActive && !$store.getters.getRedirectedFromWebToEvent && $store.getters.getCurrentMainComponent != 'PassportPage'"-->
      <!--              class="passpoortButtonToolbar text-capitalize"-->
      <!--              color="primary"-->
      <!--              round-->
      <!--              large-->
      <!--              @click="goToUserPassport()"-->
      <!--       >{{$translate('GO_TO_PASS')}}</v-btn>-->
      <!--      <v-btn-->
      <!--        v-if="currentScrollPos > 40 && $store.getters.getCurrentMainComponent == 'HomePage'"-->
      <!--        class="planTripButtonOnHome text-capitalize"-->
      <!--        color="secondary"-->
      <!--        round-->
      <!--        large-->
      <!--        @click="firePlanTrip"-->
      <!--      >{{$translate('TRIP_PLAN')}}</v-btn>-->
    </v-layout>
    <v-btn
      v-if="currentScrollPos > 40 && $store.getters.getCurrentMainComponent == 'HomePage' && $store.getters['auth/userLevel'] < 4 && $store.getters['auth/userName'] != ''"
      class="planTripButtonOnHome text-capitalize"
      color="secondary"
      round
      large
      @click="goToUserPartnerCreation()"
    >{{$translate('CREATE_PARTNER')}}</v-btn>
    <v-layout row justify-end>
      <v-btn v-if="currentUserLevel===6 && tmpPartnerAdmin" color="primary" @click="switchToAccountAdmin">Admin</v-btn>
      <div class="text-xs-center">
        <v-menu bottom origin="center center" transition="scale-transition">
          <template v-slot:activator="{ on }">
            <v-avatar size="35" class="mr-4" v-on="on">
              <img class="languageFlag" :aspect-ratio="14/9" :src="languageLogo" />
            </v-avatar>
            <!-- <v-btn
            color="primary"
            small
            fab
            v-on="on"
          >
          <v-icon>language</v-icon>
            </v-btn>-->
          </template>
          <v-list>
            <v-list-tile v-for="(item, i) in languages" :key="i" @click="changeUserLanguage(item)">
              <v-list-tile-avatar>
                <v-img :src="item.Icon"></v-img>
              </v-list-tile-avatar>
              <v-list-tile-title>{{ item.LocalName }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </div>
      <v-menu bottom left>
        <a slot="activator" class="activ_icon">
          <v-icon color="primary">menu</v-icon>
        </a>
        <v-list>
<!--          <v-card v-if="$store.getters.getUserIsCrowdScout" class="elevation-0 transparent crowdScoutImage">-->
<!--            <v-img :src="require('@/assets/ticketExample.png')">-->
<!--            </v-img>-->
          <v-layout v-if="$store.getters.getUserIsCrowdScout" justify-center>
            <v-list-tile-avatar>
              <v-img :src="require('@/assets/crowdScout/CrowdScout.png')" />
            </v-list-tile-avatar>
          </v-layout>
<!--          </v-card>-->
          <v-list-tile v-if="$store.getters['auth/userLevel'] >= 6" @click="goToHome()">
            <v-list-tile-title>{{$translate('THEME_LIST')}}</v-list-tile-title>
          </v-list-tile>
          <v-list-tile v-if="$store.getters['auth/userLevel'] >= 1" @click="goToMyActivities">
            <v-list-tile-title>{{$translate('MY_APPOINTMENTS')}}</v-list-tile-title>
          </v-list-tile>
          <v-list-tile v-if="$store.getters['auth/userLevel'] >= 1" @click="goToUserPassport()">
            <v-list-tile-title>{{$translate('USER_PASSPORT')}}</v-list-tile-title>
          </v-list-tile>
          <v-list-tile v-if="$store.getters['auth/userLevel'] >= 6" @click="goToQrScanner()">
            <v-list-tile-title>{{$translate('QR_CODE')}}</v-list-tile-title>
          </v-list-tile>
          <v-list-tile
            v-if="$store.getters['auth/userLevel'] >= 6 && $store.getters['auth/userLevel'] <= 9"
            @click="showComponents({ main: 'Events_main', side: 'EventView_Overview' })"
          >
            <v-list-tile-title>{{$translate('DASHBOARD_TITLE')}}</v-list-tile-title>
          </v-list-tile>
          <v-list-tile v-if="$store.getters['auth/userLevel'] == 6" @click="goToDeliveryRouteGenerator()">
            <v-list-tile-title>Route generator</v-list-tile-title>
          </v-list-tile>
          <v-list-tile v-if="$store.getters['auth/userLevel'] == 9" @click="goToManagement()">
            <v-list-tile-title>Management</v-list-tile-title>
          </v-list-tile>
          <v-list-tile v-if="$store.getters['auth/userLevel'] !== 0" @click="logout">
            <v-list-tile-title>Log out</v-list-tile-title>
          </v-list-tile>
          <v-list-tile v-else @click="login">
            <v-list-tile-title>Login</v-list-tile-title>
          </v-list-tile>
        </v-list>
        <!-- <v-list class="grey lighten-3"> -->
        <!-- <v-list-tile v-for="item in  ConfigList" :key="item" @click="ConfigMenu(item)">{{item}}</v-list-tile> -->
        <!-- </v-list> -->
      </v-menu>
    </v-layout>
  </v-toolbar>
  <v-toolbar v-else fixed clipped-left dark app class="zindex toolbarMobile" color="white">
    <v-toolbar-title class="ml-0 pl-0 pr-2">
      <!-- <v-btn class="ml-4" icon large> -->
      <img :src="headerImage()" @click="goToHome()" style="height: 40px; margin-top: 1em; cursor: pointer;" alt="theDrivingForce" />
      <!-- </v-btn> -->
    </v-toolbar-title>
    <!--    <v-toolbar-items class="mt-3 hidden-sm-and-down" v-if="$store.getters.getCurrentMainComponent == 'HomePage' && visitorActive">-->
    <!--      <v-btn-->
    <!--        :class="['mr-5, text-xs-center, text-capitalize']"-->
    <!--        :style="getSelectedStyleElement(item)"-->
    <!--        v-for="(item, index) in toolbarItems"-->
    <!--        :key="index"-->
    <!--        flat-->
    <!--        color="primary"-->
    <!--        round-->
    <!--        @click="goToNavigation(item)"-->
    <!--      >{{item.title}}</v-btn>-->
    <!--    </v-toolbar-items>-->
    <!--    <v-toolbar-items class="mt-3 hidden-sm-and-down" v-else-if="$store.getters.getCurrentMainComponent !== 'HomePage' && visitorActive">-->
    <!--      <v-btn-->
    <!--        :class="['mr-5, text-xs-center, text-capitalize']"-->
    <!--        flat-->
    <!--        color="primary"-->
    <!--        round-->
    <!--        @click="goToHome()"-->
    <!--      >{{$translate('THEME_LIST')}}</v-btn>-->
    <!--    </v-toolbar-items>-->
    <!--    <v-toolbar-items class="mt-3 hidden-sm-and-down" v-else>-->
    <!--      <v-btn-->
    <!--        style="opacity: 0.6;"-->
    <!--        :class="['mr-5, text-capitalize']"-->
    <!--        :style="`color: ${$vuetify.theme.primary}`"-->
    <!--        v-for="(item, index) in toolbarButtons"-->
    <!--        :key="index"-->
    <!--        :flat="!item.selected"-->
    <!--        round-->
    <!--        color="light grey"-->
    <!--        @click="selectItem(item)"-->
    <!--      >{{item.title}}</v-btn>-->
    <!--    </v-toolbar-items>-->
    <!--    <v-layout v-if="currentUserLevel < 6" row justify-end>-->

    <!--      <v-btn-->
    <!--        class="passpoortButtonToolbar text-capitalize"-->
    <!--        color="primary"-->
    <!--        round-->
    <!--        large-->
    <!--        @click="goToUserPassport()"-->
    <!--      >{{$translate('GO_TO_PASS')}}</v-btn>-->

    <!--      <v-btn-->
    <!--        v-if="currentScrollPos > 40 && $store.getters.getCurrentMainComponent == 'HomePage'"-->
    <!--        class="planTripButtonOnHome text-capitalize"-->
    <!--        color="secondary"-->
    <!--        round-->
    <!--        large-->
    <!--        @click="firePlanTrip"-->
    <!--      >{{$translate('TRIP_PLAN')}}</v-btn>-->
    <!--    </v-layout>-->
    <v-layout row justify-end>
      <!--      <v-btn v-if="currentUserLevel===6 && tmpPartnerAdmin" color="primary" @click="switchToAccountAdmin">switch to account admin</v-btn>-->
      <div class="text-xs-center">
        <v-menu bottom origin="center center" transition="scale-transition">
          <template v-slot:activator="{ on }">
            <v-avatar size="35" class="mr-4 mt-2" v-on="on">
              <img class="languageFlag" :aspect-ratio="14/9" :src="languageLogo" />
            </v-avatar>
            <!-- <v-btn
            color="primary"
            small
            fab
            v-on="on"
          >
          <v-icon>language</v-icon>
            </v-btn>-->
          </template>
          <v-list>
            <v-list-tile v-for="(item, i) in languages" :key="i" @click="changeUserLanguage(item)">
              <v-list-tile-avatar>
                <v-img :src="item.Icon"></v-img>
              </v-list-tile-avatar>
              <v-list-tile-title>{{ item.LocalName }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </div>
      <v-menu bottom left class="mr-2 mt-3">
        <a slot="activator" class="activ_icon">
          <v-icon color="primary">menu</v-icon>
        </a>
        <v-list>
<!--          <v-card class="elevation-0 transparent crowdScoutImage">-->
          <v-layout v-if="$store.getters.getUserIsCrowdScout" justify-center>
            <v-list-tile-avatar>
              <v-img :src="require('@/assets/crowdScout/CrowdScout.png')" />
            </v-list-tile-avatar>
          </v-layout>
<!--          </v-card>-->
          <v-list-tile v-if="$store.getters['auth/userLevel'] >= 6" @click="goToHome()">
            <v-list-tile-title>{{$translate('THEME_LIST')}}</v-list-tile-title>
          </v-list-tile>
          <v-list-tile v-if="$store.getters['auth/userLevel'] >= 1" @click="goToMyActivities">
            <v-list-tile-title>{{$translate('MY_APPOINTMENTS')}}</v-list-tile-title>
          </v-list-tile>
          <v-list-tile v-if="$store.getters['auth/userLevel'] >= 1" @click="goToUserPassport()">
            <v-list-tile-title>{{$translate('USER_PASSPORT')}}</v-list-tile-title>
          </v-list-tile>
          <v-list-tile
            v-if="$store.getters['auth/userLevel'] >= 6 && $store.getters['auth/userLevel'] <= 9"
            @click="goToTicketScanner"
          >
            <v-list-tile-title>scan tickets</v-list-tile-title>
          </v-list-tile>
          <v-list-tile
            v-if="$store.getters['auth/userLevel'] >= 6 && $store.getters['auth/userLevel'] <= 9"
            @click="showComponents({ main: 'Events_main', side: 'EventView_Overview' })"
          >
            <v-list-tile-title>{{$translate('DASHBOARD_TITLE')}}</v-list-tile-title>
          </v-list-tile>
          <v-list-tile v-if="$store.getters['auth/userLevel'] == 6" @click="goToDeliveryRouteGenerator()">
            <v-list-tile-title>Route generator</v-list-tile-title>
          </v-list-tile>
          <v-list-tile v-if="$store.getters['auth/userLevel'] !== 0" @click="logout">
            <v-list-tile-title>Log out</v-list-tile-title>
          </v-list-tile>
          <v-list-tile v-else @click="login">
            <v-list-tile-title>Login</v-list-tile-title>
          </v-list-tile>
        </v-list>
        <!-- <v-list class="grey lighten-3"> -->
        <!-- <v-list-tile v-for="item in  ConfigList" :key="item" @click="ConfigMenu(item)">{{item}}</v-list-tile> -->
        <!-- </v-list> -->
      </v-menu>
    </v-layout>
  </v-toolbar>
</template>

<script>
  import { ui_helpers } from "../shared/ui_helpers";
  import { mapGetters } from "vuex";
  import appConfig from "../../config/app_config";
  import BaseObject from "@/objects/BaseObject";
  import * as dssRequest from "../api/dssRequest";
  import { store } from "../store";
  import BaseComponent from "@/components/base/BaseComponent.vue";
  import Account_Main from "./Account/Account_Main";
  import TicketScanner from "./TicketScanner";
  import Vue from "vue";

  export default {
    name: "NewToolbar",
    mixins: [ui_helpers],
    extends: BaseComponent,

    computed: {
      ...mapGetters({
        currentScrollPos: "getCurrentScrollPos",
        currentAccountId: "getCurrentAccountId",
        currentUserLevel: "auth/userLevel",
        tmpPartnerAdmin: "auth/tmpPartnerAdmin"
      })
    },
    watch: {
      tmpPartnerAdmin: function(newV, oldV) {
        if (newV !== oldV && newV === true) {
          window.EventBus.fire("getPartnerPreferences");
        }
      }
    },
    created() {
      window.EventBus.listen('changeUserLanguage', this.changeUserLanguage);
      window.EventBus.listen("goToHome", this.goToHome);
      window.EventBus.listen("goToCreatePartner", this.goToUserPartnerCreation);
      setTimeout(() => {
        this.toolbarItems.forEach(e => {
          if(e.title == this.$translate("CALENDAR")){
            this.$nextTick(function () {
              e.noShow = this.$store.getters.getCalendarIsEmpty;
            })
          }
        })
      }, 100);
    },
    beforeDestroy() {
      window.EventBus.removeListener('changeUserLanguage', this.changeUserLanguage);
      window.EventBus.removeListener("goToHome", this.goToHome);
      window.EventBus.removeListener("goToCreatePartner", this.goToUserPartnerCreation);
    },
    data() {
      return {
        languages: [],
        languageLogo: "",
        isLoggedIn: false,
        showLogin: false,
        showPushNotifications: false,
        toolbarButtons: [],
        ConfigList: ["Home", "Logout"],
        toolbarItems:  [
          {
            title: this.$translate("THEMES"),
            selected: false,
            link: { main: "Home", side: "" },
            noShow: false,
          },
          {
            title: this.$translate("CALENDAR"),
            selected: false,
            noShow: false,
          },
          {
            title: this.$translate("WHAT_IS_WHERE"),
            selected: false,
            noShow: false,
          }
        ],
      };
    },
    mounted() {
      this.$store.commit("setCurrentScrollPos", 0);
      this.setToolbarButtons();
      this.userLevelClearance();
      if (this.$store.getters.getUserLanguage !== "" && this.$store.getters.getUserLanguage) {
        this.changeUserLanguage(this.$store.getters.getUserLanguage);
      } else {
        this.$store.commit("setLanguage", "NL");
        this.$store.commit("setUserLanguage", "14");
        this.languageLogo = require("@/assets/countryIcons/netherlands.png");
      }
      this.getAllLanguageTags();
      if(this.$store.getters.getSelectedItem) {

        this.selectItem(this.$store.getters.getSelectedItem);
        this.$store.commit("setSelectedItem", null);
      }
    },
    methods: {
      setToolbarButtons() {

        // Fill the toolbar options based on userLevel
        if (this.$store.getters['auth/userLevel'] == 9) {
          this.toolbarButtons =  [
            {
              title: this.$translate("LOCATIONS"),
              selected: false,
              link: { main: "Locations_Main", side: "NavigationOverview" }
            },
            {
              title:
                this.$store.getters["auth/userLevel"] == 6
                  ? "Partner Management"
                  : this.$translate("ACCOUNT_MNG"),
              selected: false,
              link: { main: "Account_Main", side: "" }
            },
            {
              title: this.$translate("EVENTS"),
              selected: false,
              link: { main: "Events_main", side: "EventView_Overview" }
            },
            {
              title: this.$translate("OP_SCREEN"),
              selected: false,
              link: { main: "OperationalScreen_Main", side: "" }
            },
            {
              title: this.$translate("FINANCIAL_MANAGEMENT"),
              selected: false,
              link: { main: "Financial_Main", side: "" }
            },
            {
              title: this.$translate("STATISTICS"),
              selected: false,
              link: { main: "Statistics_Main", side: "" }
            },
          ];
        } else {
          this.toolbarButtons = [
            {
              title: this.$translate("LOCATIONS"),
              selected: false,
              link: {main: "Locations_Main", side: "NavigationOverview"}
            },
            {
              title:
                this.$store.getters["auth/userLevel"] == 6
                  ? "Partner Management"
                  : this.$translate("ACCOUNT_MNG"),
              selected: false,
              link: {main: "Account_Main", side: ""}
            },
            {
              title: this.$translate("EVENTS"),
              selected: false,
              link: {main: "Events_main", side: "EventView_Overview"}
            },
            {
              title: this.$translate("OP_SCREEN"),
              selected: false,
              link: {main: "OperationalScreen_Main", side: ""}
            },
            {
              title: this.$translate("FINANCIAL_MANAGEMENT"),
              selected: false,
              link: {main: "Financial_Main", side: ""}
            },
            {
              title: this.$translate("STATISTICS"),
              selected: false,
              link: {main: "Statistics_Main", side: ""}
            },
            {
              title: this.$translate('ORDERS'),
              selected: false,
              link: {main: "Orders_Main", side: ""}
            }
          ];
        }
        // //
        // if (this.$store.getters["auth/userLevel"] == 9) {
        //
        //     this.toolbarButtons.forEach((element, key) => {
        //       if (element.title == "Orders") {
        //         this.toolbarButtons.splice(key, 1)
        //       }
        //     })
        // }

      },
      switchToAccountAdmin() {
        // Switch back to Account Admin from Partner Admin
        console.log("Going to switch to account admin");
        store.commit("auth/setUserLevel", 9); // Account admin
        store.commit("auth/setPartnerId", -1);
        store.commit("auth/setTmpPartnerAdmin", false);
        const payload = {
          FunctionId: "UserFunctionLibrary::switchUserLevel"
        };
        dssRequest.doRequest(
          response => {
            console.log("The generic call switchUserLevel was successful", response);
            window.EventBus.fire("getAccountInfo", {});
            location.reload();
          },
          error => {
            console.log("The generic call switchUserLevel was not successful", error);
          },
          "communicateWithDBLibrary",
          store.getters.getCurrentAccountId,
          payload
        );
      },

      getPartners() {
        // Action for loading all the Partners in the current account
        const payload = {
          FunctionId: "AccountFunctionLibrary::getPartners"
        };
        dssRequest.doRequest(
          response => {
            console.log("the call for getPartners was successful", response);
            console.log("the call for getPartners was successful", this.$route.query.email);
            for (let [key, value] of Object.entries(response.data.Partners)) {

            }
          },
          error => {
            console.log("the call for getPartners was not successful", error);
          },
          "communicateWithDBLibrary",
          this.currentAccountId,
          payload
        );
      },
      goToCalendar(){
        this.$store.commit("setSelectedItem", null);
        this.$router.push({
          name: "Calendar",
          params: {
            type: "u",
            account_id: this.$store.getters.getRegion,
            partner_id: Number(this.$store.getters.getSavePartnerId)
          }
        });
      },
      goToNavigation(item) {
        if (item.title === "Whats on") {
          window.EventBus.fire("fireScrollMeTo", "homepageCalendar")
        } else if (item.title === "What's where") {
          window.EventBus.fire("fireScrollMeTo", "homepageMapSection")
        } else {
          window.EventBus.fire("fireScrollMeTo", "homepageThemes")
        }
      },
      changeUserLanguage(item) {
        if (!item.hasOwnProperty("LocalName")) {
          if (item == "13") {
            this.languageLogo = require("@/assets/countryIcons/united-kingdom.png");
            this.$store.commit("setUserLanguage", item);
            this.$store.commit("setLanguage", "EN");
            if (this.$route.fullPath.includes('home')) {
              // deleted fireNewLanguage()
            }
          } else if (item == "14") {
            this.languageLogo = require("@/assets/countryIcons/netherlands.png");
            this.$store.commit("setUserLanguage", item);
            this.$store.commit("setLanguage", "NL");
            if (this.$route.fullPath.includes('home')) {
              // deleted fireNewLanguage()

            }
          } else if (item == "15") {
            this.languageLogo = require("@/assets/countryIcons/italy.png");
            this.$store.commit("setUserLanguage", item);
            this.$store.commit("setLanguage", "EN");
            if (this.$route.fullPath.includes('home')) {
              // deleted fireNewLanguage()
            }
          } else if (item == "16") {
            this.languageLogo = require("@/assets/countryIcons/france.png");
            this.$store.commit("setUserLanguage", item);
            this.$store.commit("setLanguage", "EN");
            if (this.$route.fullPath.includes('home')) {
              // deleted fireNewLanguage()
            }
          } else if (item == "17") {
            this.languageLogo = require("@/assets/countryIcons/germany.png");
            this.$store.commit("setUserLanguage", item);
            this.$store.commit("setLanguage", "DE");
            if (this.$route.fullPath.includes('home')) {
              // deleted fireNewLanguage()
            }
          }
        } else {

          this.languageLogo = item.Icon;
          this.$store.commit("setUserLanguage", item.LanguageId);
          if (this.$store.getters["auth/userName"] !== "") {
            this.updateLanguage(item.LanguageId);
          } else {
            if (this.$route.fullPath.includes('home')) {
              window.EventBus.fire("fireNewLanguage", {});
              window.EventBus.fire("fireNewUserLanguage", {});
            }
          }
          if (item.LanguageTagId === "14") {
            this.$store.commit("setLanguage", "NL");
          } else if (item.LanguageTagId === "17") {
            this.$store.commit("setLanguage", "DE");
          } else {
            this.$store.commit("setLanguage", "EN");
          }
        }
      },
      firePlanTrip() {
        window.EventBus.fire('firePlanTrip');
      },
      showLanguageChanges() {
        this.toolbarButtons = [];
        this.toolbarItems = [];
        this.setToolbarButtons();
        this.toolbarItems=  !_.isEmpty(this.$store.getters.getSavePartnerId) || this.$store.getters.getRedirectedFromPearlCalendar ? [
            {
              title: this.$translate("CALENDAR"),
              selected: false
            },
            {
              title: this.$translate("THEMES"),
              selected: false,
              link: { main: "Home", side: "" }
            }
          ] :
          [
            {
              title: this.$translate("THEMES"),
              selected: false,
              link: { main: "Home", side: ""}
            }
          ]
      },
      updateLanguage(id) {
        if(!_.isEmpty(this.$store.getters["auth/userName"])){
          const payload = {
            LanguageTagId: Number(id)
          };
          dssRequest.doRequest(
            response => {
              console.log(
                "The generic call updateLanguage was successful",
                response
              );
              window.EventBus.fire("fireNewLanguage", {});
              window.EventBus.fire("fireNewUserLanguage", {});

              this.showLanguageChanges();
            },
            error => {
              console.log(
                "The generic call updateLanguage was not successful",
                error
              );
            },
            "updateLanguage",
            this.$store.getters["auth/userName"],
            payload
          );
        }
      },
      // Get all language tags from the database.
      getAllLanguageTags() {
        // This used to be the generic call getAllLanguageTags
        const payload = {};
        dssRequest.doRequest(
          response => {
            console.log(
              "The generic call getAllLanguageTags was successful",
              response
            );
            if (!response.hasOwnProperty("data")) {
              console.error(
                "[" +
                this.$options.name +
                "] Response on getAllLanguageTags() doesn't have data."
              );
              return;
            }

            if (!response.data.hasOwnProperty("Languages")) {
              console.error(
                "[" +
                this.$options.name +
                "] Response on getAllLanguageTags() doesn't have Languages."
              );
              return;
            }

            this.languages = [];
            this.languages = [...response.data.Languages];
            
            this.languages.forEach(data => {
              if(data.Icon === '' || data.Icon === 'NULL') {
                if (data.LanguageId == "13") {
                  data.Icon = require("@/assets/countryIcons/united-kingdom.png");
                } else if (data.LanguageId == "14") {
                  data.Icon = require("@/assets/countryIcons/netherlands.png");
                } else if (data.LanguageId == "15") {
                  data.Icon = require("@/assets/countryIcons/italy.png");
                } else if (data.LanguageId == "16") {
                  data.Icon = require("@/assets/countryIcons/france.png");
                } else if (data.LanguageId == "17") {
                  data.Icon = require("@/assets/countryIcons/germany.png");
                }
              }
            });
            console.log("langauges", this.languages);

            this.$store.commit("setLanguages", this.languages);

          },
          error => {
            console.log(
              "The generic call getAllLanguageTags was not successful",
              error
            );
          },
          "getAllLanguageTags",
          this.currentAccountId,
          payload
        );
      },
      getSelectedStyleElement(item) {
        // console.log("item " + item.title + " is selected: " + item.selected + " color primary is : " + this.$vuetify.theme.primary + " color secondary is: " + this.$vuetify.theme.secondary);
        return (
          "color:" +
          (item.selected
            ? this.$vuetify.theme.primary
            : this.$vuetify.theme.secondary)
        );
      },
      selectItem(item) {
        this.toolbarButtons.forEach(e => {
          e.selected = e.title == item.title;

          if (e.selected) {
            console.log("comitting item: ", e);
            this.$store.commit("setSelectedItem", e);
            console.log("ikkkk mounted ", this.$store.getters.getSelectedItem);

          }
        });
        this.showComponents(item.link);
      },
      userLevelClearance(){
        if (this.$store.getters["auth/userLevel"] >= 0 && this.$store.getters["auth/userLevel"] <= 5) {
          this.$store.commit("setVisitorActive", true);
        } else if (
          this.$store.getters["auth/userLevel"] >= 6 &&
          this.$store.getters["auth/userLevel"] <= 9
        ) {
          this.$store.commit("setVisitorActive", false);
        }
      },
      ConfigMenu(item) {
        switch (item) {
          case "Home":
            this.$router.push({
              name: "Home",
              params: {
                type: "u",
                account_id: store.getters.getRegion
              }
            });
            break;
          case "Logout":
            console.log(" logging out at NEW TOOLBAAR!!")
            this.$store.dispatch("auth/logout");
            this.$store.commit("setUserIsCrowdScout", false);
            window.EventBus.fire("getAccountInfo", {});
            this.$store.commit("setRedirectedFromPearlCalendar", true);
            this.$router.push({
              name: "Home",
              params: {
                type: "u",
                account_id: this.$store.getters.getRegion
              }
            });
            window.EventBus.fire("activateSnackBar", this.$translate('USER_LOGGED_OUT'));
            break;
        }
      },
      setUserHomepage() {
        this.$store.commit("setWebStepId", 2);
      },
      goToMyActivities() {
        this.$store.commit("setSelectedItem", null);
        this.$store.commit("setNoBackground", true);
        this.goToPage("TripList");
        // this.$store.commit("setWebStepId", 2);
      },
      goToUserSettings() {
        this.$store.commit("setSelectedItem", null);
        this.goToPage('UserSettings');
      },
      goToManagement() {
        // Redirect the admin user to the management screen
        this.$store.commit("setSelectedItem", null);
        this.goToPage("ObjectManagement");
      },
      goToUserPassport() {
        if (this.$store.getters["auth/userName"] == ""){
          this.$store.commit("setClickedOnPasspoortButton", true)
          this.$store.commit("setUserIsCreatingPassport", true)
          this.$router.push({
            name: "Login",
            params: "component"
          });
        }
        else{
          this.$store.commit("setSelectedItem", null);
          this.$router.push({
            name: "PassportPage",
            params: {
              type: "u",
              account_id: this.$store.getters.getRegion,
              partner_id: Number(this.$store.getters.getSavePartnerId)
            }
          });
        }
      },
      goToUserPartnerCreation() {
        if (this.$store.getters["auth/userName"] == ""){
          this.$store.commit('setPartnerCreate', true);
          this.$router.push({
            name: "Login",
            params: "component"
          });
        }
        else{
          this.$store.commit("setSelectedItem", null);
          this.$router.push({
            name: "PartnerCreation",
            params: {
              type: "u",
              account_id: this.$store.getters.getRegion,
              partner_id: Number(this.$store.getters.getSavePartnerId)
            }
          });
        }
      },
      goToHome() {
        console.log("I'm going home")
        this.$store.commit('setCurrentMainComponent', 'HomePage');
        this.$store.commit("setSelectedItem", null);
        this.$router.push({
          name: "Homepage",
          params: {
            account_id: this.$store.getters.getRegion
          }
        });

        this.$store.commit("setWebStepId", 1);
      },
      goToQrScanner() {
        console.log("I'm going to scan a QR-code")
        this.$store.commit("setSelectedItem", null);
        this.$router.push({
          name: "QrScanner"
        });

        this.$store.commit("setWebStepId", 1);
      },
      goToDeliveryRouteGenerator() {
        this.$store.commit("setSelectedItem", null);
        this.$router.push({
          name: "DeliveryRouteGenerator"
        });

        this.$store.commit("setWebStepId", 1);
      },
      goToTicketScanner() {
        console.log("going to the ticketscanner");
        this.$store.commit("setSelectedItem", null);
        this.$router.push({
          name: "TicketScanner"
        });
      },
      goToMap() {
        this.$router.push({
          name: "MapOverview",
          params: {
            type: "u",
            account_id: this.currentAccountId
          }
        });
      },
      login() {
        this.$store.commit("setSelectedItem", null);
        this.$store.commit("setClickedOnPassportButton", false);
        this.$router.push({
          name: "Login",
        });
      },
      logout() {
        // google sign out
        Vue.GoogleAuth.then((auth2) => {
          if (auth2.isSignedIn.get()) {
            auth2.signOut();
          }
        });

        // facebook sign out
        if (window.FB !== undefined) {
        window.FB.getLoginStatus((response) => {
          if (response.status === 'connected') {
            window.FB.logout();
          }
        });
        }
        this.$store.commit("setUserIsCrowdScout", false);
        this.$store.commit("setSavePartnerId", '');
        this.$store.commit("setRedirectedFromPearlCalendar", false);
        this.$store.commit('auth/setUserLevel', 0);
        window.EventBus.fire("getAccountInfo", {});
        this.$store.commit("setSelectedItem", null)
        this.userLevel = 0;
        this.$store.commit("setVisitorActive", true);
        this.$store.dispatch("auth/logout");
        this.$router.push({
          name: "Homepage",
          params: {
            type: "u",
            account_id: this.$store.getters.getRegion
          }
        });
        window.EventBus.fire("activateSnackBar", this.$translate('USER_LOGGED_OUT'));
      },
      goToPassport() {
        // Register/login first, than move to passport Page
        this.goTo("Login");
        this.$store.commit("setUserIsCreatingPassport", true)
      }
    }
  };
</script>

<style scoped>
  .toolbarMobile {
    width: 100%;

  }

  #NL {
    float: left;
    display: none;
  }

  #EN {
    float: left;
  }
  .v-expansion-panel__header {
    border-bottom: 1px solid black !important;
  }
  .languageFlag {
    cursor: pointer;
  }
  .zindex {
    height: 80px !important;
    /*padding: 1px 14em !important;*/
  }
  .planTripButtonOnHome {
    margin-top: 1em;
    margin-left: 1em !important;
    transform: scale(1.0);
  }
  .planTripButtonOnHome:hover {
    transform: scale(1.0);
  }
  .passpoortButtonToolbar{
    margin-top: 1em;
    margin-right: 2em !important;
    transform: scale(1.0);
    margin-left: 25em;
  }
  .passpoortButtonToolbar:hover {
    transform: scale(1.0);
  }
</style>
